import {requests} from '../../services';
import {LIST_OFFER_URL} from '../../utils/Endpoints';
import {BaseModel} from '../../model/shared/BaseModel';
import {Offer} from '../../model/offer/Offer';

export const OfferService = {
    getOffers: (params: any): Promise<BaseModel<Offer>> => requests.get(`${LIST_OFFER_URL}`, params),
    editOffer: (id: number, body: Offer): Promise<Offer> => requests.put(`${LIST_OFFER_URL}/${id}`, body),
}
